export const ThemeFontFamily = {
  sans: `'Metropolis', sans-serif`,
  regular: `'Metropolis', sans-serif`,
  bold: `'Metropolis Bold', sans-serif`,
  condensed: `'Metropolis', sans-serif`,
} as const;
